<template>
  <div
    class="bg-white h-full p-3.5 rounded-md border border-grayNeutralLight flex items-center justify-center flex-col gap-1">
    <div>
      <svg width="64" height="60" viewBox="0 0 64 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_775_28357)">
          <path
            d="M31.1328 27.4872C31.1328 29.1526 32.4717 30.5001 34.1266 30.5001H41.9813C43.3153 30.5001 44.3972 29.4113 44.3972 28.0688C44.3972 26.7263 43.3153 25.6375 41.9813 25.6375C41.5665 25.6375 41.1763 25.7421 40.8354 25.931C40.4846 24.6582 39.3238 23.7236 37.9504 23.7236C36.9971 23.7236 36.1473 24.1712 35.6039 24.867C35.1693 24.6185 34.6654 24.4743 34.1269 24.4743C32.4717 24.4743 31.1331 25.8218 31.1331 27.4872H31.1328Z"
            stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M19.8965 23.1699C19.6012 23.4125 19.3756 23.7112 19.2258 24.0422C18.1699 23.2177 16.6568 23.1653 15.5355 24.0062C14.7569 24.59 14.3334 25.4756 14.3106 26.3767C13.8054 26.44 13.3067 26.6307 12.8669 26.9605C11.5153 27.9739 11.2367 29.894 12.2437 31.2539C13.2506 32.6141 15.1582 32.8945 16.5098 31.8811L19.8968 29.3412"
            stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M29.7641 25.6635C29.2182 25.3182 28.8555 24.7065 28.8555 24.0098C28.8555 22.9319 29.7237 22.0581 30.7948 22.0581C31.6945 22.0581 32.4512 22.6748 32.6703 23.5111"
            stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M30.8613 19.1514V20.1824" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M26.0234 23.9785H27.0483" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M34.028 20.4385L33.3086 21.1726" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M28.0104 26.4795L27.291 27.2136" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M27.373 20.4053L28.0924 21.1391" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M59.8095 17.6885H23.8125V48.1141H59.8095V17.6885Z" stroke="#C0C4CC" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M63.7231 13.4604H19.8984V59.7208H63.7231V13.4604Z" stroke="#C0C4CC" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M24.4473 13.3517L36.4455 6.34814L40.4733 13.3368" stroke="#C0C4CC" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M19.8973 49.8407L5.30664 24.5237L19.897 16.0073" stroke="#C0C4CC" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M19.8976 57.2671L0.277344 23.2222L38.1872 1.09424L45.3139 13.4604" stroke="#C0C4CC"
            stroke-linecap="round" stroke-linejoin="round" />
          <path d="M23.8125 45.7102L31.8771 33.9653L38.3255 42.4054" stroke="#C0C4CC" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M36.284 39.8375L33.8256 42.4766L31.7938 40.3487L30.2835 41.8687L28.1133 39.4448" stroke="#C0C4CC"
            stroke-linecap="round" stroke-linejoin="round" />
          <path d="M34.4648 48.1067L50.768 25.6636L59.8085 37.7512" stroke="#C0C4CC" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M58.2647 35.6869L53.981 40.0727L50.4115 36.3696L47.9127 38.8844L44.0723 35.3057" stroke="#C0C4CC"
            stroke-linecap="round" stroke-linejoin="round" />
          <path d="M50.2007 30.7275L48.2148 33.6061" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M32.2949 51.3267H40.224" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M40.6387 54.1938H48.6019" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M58.7316 57.1743H56.0957" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M52.882 57.1743H28.0312" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M3.99219 53.2134H6.62873" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M5.31055 51.8867V54.5401" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M54.709 1.60596H57.3455" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M56.0273 0.279297V2.93269" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
          <clipPath id="clip0_775_28357">
            <rect width="64" height="60" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div class="mt-1 w-full">
      <div class="font-bold text-center text-15px pb-0.5">
        <slot name="title"></slot>
      </div>
      <div class="text-center text-13px text-grayNeutralDark">
        <slot name="info"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>
